import { useLanguageStore } from '../../store/languageStore';
import { useMenuStore } from '../../store/menuStore';
import './Menu.css';

const languages = [
  { code: 'en', name: 'English', flag: '🇬🇧' },
  { code: 'fi', name: 'Suomi', flag: '🇫🇮' },
  { code: 'se', name: 'Svenska', flag: '🇸🇪' },
  { code: 'es', name: 'Español', flag: '🇪🇸' },
] as const;

export default function LanguageSelector() {
  const { currentLanguage, setLanguage } = useLanguageStore();
  const { isLanguageMenuOpen, toggleLanguageMenu, closeAllMenus } = useMenuStore();

  const handleLanguageChange = (lang: typeof languages[number]['code']) => {
    setLanguage(lang);
    closeAllMenus();
  };

  return (
    <div className="language-selector">
      <button
        className="language-selector__button"
        onClick={toggleLanguageMenu}
        aria-label="Select language"
      >
        {languages.find((l) => l.code === currentLanguage)?.flag || '🌐'}
      </button>
      {isLanguageMenuOpen && (
        <div className="language-selector__menu">
          {languages.map((lang) => (
            <button
              key={lang.code}
              className={`language-selector__option ${currentLanguage === lang.code ? 'language-selector__option--active' : ''}`}
              onClick={() => handleLanguageChange(lang.code)}
            >
              <span>{lang.flag}</span>
              <span>{lang.name}</span>
            </button>
          ))}
        </div>
      )}
    </div>
  );
}

